import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';
import useClientsEventBookingGql from './useClientsEventBookingGql';
import ensureInputHash from '../../../../../../base/utils/ensureInputHash';
import useClientsEventBookingContext from './useClientsEventBookingContext';
import useDeleteNode from '../../../../../../base/hooks/useDeleteNode';
import useNotificationStateContext from '../../../../../../base/hooks/useNotificationStateContext';

const useClientsEventBookingFormMutation = () => {
  const { proceedTo, setClientsEventBooking } = useClientsEventBookingContext();
  const { useClientsEventBookingMutation } = useClientsEventBookingGql();
  const { triggerNotification } = useNotificationStateContext();
  const [mutation] = useClientsEventBookingMutation();
  const { useRouter, useMutation } = useAppContext();
  const { pushPath } = useRouter();
  const [deleteClient] = useDeleteNode().useDeleteNodeMutation();

  const proceed = (path = null) => {
    if (path) return pushPath(path);
    return pushPath(proceedTo);
  };

  const cancelBooking = (gid, path) => {
    deleteClient({ variables: ({ gid }) })
      .then((response) => {
        const { data: { deleteNode: { success } }, errors } = response;
        if (success) {
          pushPath(path);
          // triggerNotification('Appointment has been canceled!', 'warning');
        }
        return false;
      });
  };

  const mutate = (input, { canProceed = true, onboardingProceed, newAppointmentProceed = false, thankyou = false }) => {
    let gid;
    mutation({ variables: { input: ensureInputHash(input) } })
      .then((response) => {
        const { data: { clientsEventBooking: { errors, clientsEvent } } } = response;
        if (errors) {
          triggerNotification(errors, 'error');
        } else if (clientsEvent) {
          setClientsEventBooking(clientsEvent);
          gid = clientsEvent.gid;
          if (canProceed) proceed();
          if (onboardingProceed) proceed(`${process.env.PROXY_PATH}/booking/appointment/${gid}/availabilities`);
          if (newAppointmentProceed) proceed(`${process.env.PROXY_PATH}/booking/new_appointment/${gid}/availabilities`);
          if (thankyou) proceed(`${process.env.PROXY_PATH}/booking/appointment/${gid}/thankyou`);
          return clientsEvent;
          // triggerNotification('Event has been successfuly saved!');
        }
        return false;
      });
  };


  return {
    mutate,
    proceed,
    cancelBooking,
  };
};

export default useClientsEventBookingFormMutation;
